"use client";
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { getProfile } from '@/profiles/getProfile';
import { BreadcrumbSiteBaseUrl } from './BreadcrumbSiteBaseUrl';

export const CookieCheck = ({ location, isLandingPage = false, locale, displayNames } : { location: string | string[], isLandingPage?: boolean, locale?: string, displayNames?: string }) => {
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE);
  const siteBasePath = BreadcrumbSiteBaseUrl(profile);
  useEffect(() => {
    if (typeof window !== "undefined") {
      // prevent articles, case-studies, video post pages from updating the breadcrumb cookie. 
      // Check that the page isn't a landing page at base URL (i.e. the locale)
      if(isLandingPage === true || window?.location?.pathname?.includes('tags') || window?.location?.pathname?.includes('collection')){
        const siteBaseLocale = `${siteBasePath}${locale}`;
        // for a tag page, grab the 'tags' text and the tag name itself.
        let cookieUrl;
        if(window?.location?.href === siteBaseLocale) {
          cookieUrl = null;
          // reset the cookie if user hits a landing page - we don't want to keep the previous tag/collection page if the user has just hit a landing page
          Cookies.remove("breadcrumbPreviousPage");
        } else {
          const pageUrlSplit = `${profile?.BASE_URL}${window?.location?.pathname}`.split('/');
          if(window?.location?.pathname?.includes('collection')){
            // if we're on a collection page, add /collection/ to the cookie url
            cookieUrl = `${siteBaseLocale}/collection/${pageUrlSplit[pageUrlSplit?.length - 2]}/${pageUrlSplit[pageUrlSplit?.length - 1]}`
          } else {
            cookieUrl = `${siteBaseLocale}/${pageUrlSplit[pageUrlSplit?.length - 2]}/${pageUrlSplit[pageUrlSplit?.length - 1]}`;
          }
          const cookieValue = JSON?.stringify({ "text": displayNames ? displayNames : cookieUrl, "link": cookieUrl });
          Cookies.set("breadcrumbPreviousPage",  cookieValue);
        }
      }
    }
  }, [location, isLandingPage, locale, displayNames, siteBasePath, profile?.BASE_URL]);
  return null;
}

